import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';
import InfiniteMarquee from 'vanilla-infinite-marquee';

import Alpine from 'alpinejs';
import debounce from '~/utils/debounce';
import { getBreakpoint } from '../utils/utils';
const header = () => ({
  scrollStatus: 0,
  logoWidth: 0,
  scrollLogoWidth: 0,
  headerHeight: 0,
  route: '',
  disabled: false,
  open: false,
  headerNavSubmenus: null,
  stickyHeaderHeight: 0,
  activeMenu: null,
  toggleMenu(menu) {
    Alpine.store('cart').toggle(false)
    if (window.innerWidth > getBreakpoint('lg')) {
      this.activeMenu = this.activeMenu === menu ? null : menu
      this.activeSubmenu = null
    }
  },

  handleResize() {
    this.activeMenu = null
  },

  onScroll() {
    const width = document.body.clientWidth
    this.stickyHeaderHeight = (width / 808) * 139
    document.body.style.setProperty(
      '--space-sticky-header',
      this.route === '/' ? `${this.stickyHeaderHeight}px` : '0px'
    )
    const logoContainer = this.$refs.stickyLogo?.querySelector('.sticky-logo')
    const maxScroll = 250
    const scrollPosition = this.route === '/' ? window.pageYOffset : 250
    this.scrollStatus = Math.max(0, Math.min(scrollPosition / maxScroll, 1))
    this.scrollLogoWidth = `${this.logoWidth + ((logoContainer?.clientWidth || 0) - this.logoWidth) * (1 - this.scrollStatus)}px`
  },

  init() {
    new InfiniteMarquee({
	element: this.$refs.announcementElement,
	speed: 25000,
	direction: 'right',
	gap: '15px',
	duplicateCount: 2,
  destroyOnDesktop: true,

});
    this.handleResize = debounce(() => {
      this.open = this.open && window.innerWidth <= getBreakpoint('lg')
      this.onScroll()
      console.log('Resize event triggered, open:', this.open);
    }, 300)

    this.route = window.location.pathname

    this.$nextTick(() => {
      this.onScroll()
    })

    this.$watch('headerHeight', () => {
      document.body.style.setProperty(
        '--space-header',
        `${this.headerHeight}px`
      )
    })

    this.$watch('route', () => {
      this.onScroll()
    })

    this.$watch(
      () => Alpine.store('cart').visible,
      v => {
        if (v) {
          this.activeMenu = null
        }
      }
    )

    this.$watch(() => [this.open, this.activeMenu, Alpine.store('cart').visible], (v) => {
      if (v.some(x => x)) {
        disablePageScroll()
      }
      else {
        enablePageScroll()
      }
    })
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('window.navigation', () => {
      this.route = window.location.pathname
      this.open = false
      this.activeMenu = null
    })

    window.addEventListener('cart-updated', () => {
      this.activeMenu = null
    })
  },
})

export default header
